// extracted by mini-css-extract-plugin
export default {"normalXl2":"styles_normalXl2__GALCg","normalSm":"styles_normalSm__z8Gva","normalSmEn":"styles_normalSmEn__5zN0e"};